import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HandoutSeServiceResponse, Transport } from '../model/supplementary-equipment-handout';
import { AppServerAPI, Identity } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class SupplementaryEquipmentHandoutService {

  constructor(
    private appServerAPI: AppServerAPI,
  ) { }

  getTransport(transportIdentity: Identity): Observable<Transport> {
    return this.appServerAPI.execute<Transport>('/client/control/supplementaryequipment/handout/transport', transportIdentity);
  }

  saveTransport(transport: Transport): Observable<HandoutSeServiceResponse> {
    return this.appServerAPI.execute<any>('/client/control/supplementaryequipment/handout/save', transport);
  }

}
